module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "loading": _vm.enableLoading,
      "size": "small",
      "type": "success",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeAttrInBtnGroup(1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.disableLoading,
      "size": "small",
      "type": "warning",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeAttrInBtnGroup(0)
      }
    }
  }, [_vm._v("禁用")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e8e35b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/btn-group.vue
// module id = 1813
// module chunks = 2